<template>
  <div class="main-wrapper ">

    <div class="header-wrap flex w-full py-2 mt-2">
      <div class="w-6/12">
        <h6 :style="`color: #9BA0A7; font-size: 12px; font-weight: 500;`">Name</h6>
      </div>
      <div class="w-6/12">
        <h6 :style="`color: #9BA0A7; font-size: 12px; font-weight: 400;`">Amount</h6>
      </div>
      <div class="w-4/12">
        <h6 style="color: #9BA0A7; font-size: 12px; font-weight: 400;">Percentage</h6>
      </div>
    </div>


    <!-- <div class="flex w-full list-contain py-2 px-2" v-for="(value, key) in computedDataList" :key="key"> -->
    <div class="flex w-full list-contain " v-for="(value, key) in computedDataList" :key="key">

      <div class="w-6/12">
        <span class="w-full block" :style="keyStyles[key]">     
          {{ labelMap[key] || key }}
          </span>
      </div>

      <div class="w-6/12">
        <span class="w-full flex  items-center">
          <abbr class="list-amount">
            ₦ {{ formatValue(value.amount) }}
          </abbr>
        </span>
      </div>
      
      <div class="w-4/12">
        <span v-if="value.percentage !== null" class="text-sm opacity-80">
          {{ value.percentage.toFixed(2) }}%
        </span>
        <span v-else class="text-sm opacity-50">—</span>
      </div>
    </div>
   
  </div>
</template>

<script>
export default {
  
  props: {
    entDataList: { type: Object },
  },
  data() {
    return {
       keyStyles: {
        private: "color: #D72638; font-weight: 400; font-size: 14px;",
        corporate: "color: #09B78A; font-weight: 400; font-size: 14px;",
        total: "color: #10233E; font-weight: 600; font-size: 14px;",
      },
      labelMap: {
        private: "Private",
        corporate: "Corporate",
        total: "Total (NGN)",
      },
    };
  },

    computed: {
    computedDataList() {
      if (!this.entDataList) return {};

      const corporate = this.entDataList.corporate?.amount || 0;
      const privateAmt = this.entDataList.private?.amount || 0;
      const total = corporate + privateAmt;

      return {
        ...this.entDataList,
        total: { amount: total, percentage: null }, // add total row
      };
    },
  },

   methods: {
       formatValue(val) {
           const formatter = new Intl.NumberFormat("en-NG", {
               minimumFractionDigits: 2,
               maximumFractionDigits: 2,
           });
           return formatter.format(Number(val));
       },
    },
  
};
</script>

<style lang="scss" scoped>

.list-amount {
  // display: block;
  white-space: nowrap;
  width: calc(100% - 80px);
  color: #10233E;
  font-size: 14px;
  font-weight: 400;
 
}



.list-contain:nth-child(even) {
  background: #f3f4f6; /* tailwind bg-gray-200 */
  
}
.main-wrapper {
  @apply w-full flex px-3 flex-wrap;
}
</style>
